import React, { useEffect, useState } from "react";
import {
  FaSignOutAlt,
  FaCog,
  FaHistory,
  FaClipboardList,
  FaBirthdayCake,
} from "react-icons/fa";
import { firebaseSignOut } from "../firebase/AuthService";
import { FormEvent } from "react";
import logowithe from "../assets/logo3.png";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserId } from "../data/userService";
import { getDatabase, onValue, ref } from "firebase/database";
import { RiAdminFill } from "react-icons/ri";
import { IoMdTrophy } from "react-icons/io";
import { Fa0, Fa1, Fa2, Fa3, Fa4, Fa5 } from "react-icons/fa6";
import { listenTorneio } from "../data/torneioService";
import { IoStatsChartSharp } from "react-icons/io5";
import { MdOutlineRule } from "react-icons/md";

interface MenuProps {
  isCollapsed: boolean;
}

const Menu: React.FC<MenuProps> = ({ isCollapsed }) => {
  const privilegedLevels = ["admin", "dev"];
  const [error, setError] = useState<string | null>(null);
  const [jogosDoMes, setJogosDoMes] = useState<number>(8);
  const [userLevel, setUserLevel] = useState<string | null>(null);
  const [torneioExiste, setTorneioExiste] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentUserId = getUserId();
    if (!currentUserId) return;

    const db = getDatabase();
    const userRef = ref(db, `users/${currentUserId}`);

    const unsubscribe = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const jogosMes = userData.totalJogos ?? 0;
        setUserLevel(userData.level ?? null);
        setJogosDoMes(jogosMes);
      }
    });

    return () => unsubscribe(); // remove o listener quando o componente for desmontado
  }, []);

  useEffect(() => {
    const unsubscribe = listenTorneio((data) => {
      const userId = getUserId();
      const torneioExiste = !!data?.criadoEm;
      setTorneioExiste(torneioExiste);

      // Só faz a lógica de torneio se o usuário estiver na página de torneios
      if (location.pathname.startsWith("/torneios")) {
        if (!torneioExiste) {
          // se não existe torneio, fica apenas na /torneios
          if (location.pathname !== "/torneios") {
            navigate("/torneios");
          }
          return;
        }

        const tipo = data?.tipo;
        const iniciado = data?.iniciado;
        const inscrito = userId ? data?.inscritos?.[userId] : null;

        if (!iniciado && tipo && inscrito) {
          navigate(`/torneios/${tipo}`);
        }
      }
    });

    return () => unsubscribe();
  }, [navigate, location.pathname]);

  const handleLogoff = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await firebaseSignOut();
      navigate("/login");
    } catch (erro) {
      setError("Logoff failed.");
      console.error("Logoff error:", error);
    }
  };
  const getIconeJogos = (jogos: number) => {
    const iconProps =
      jogos === 8 ? "text-xl text-pink-500" : "text-xl text-pink-500";

    switch (jogos) {
      case 0:
        return <Fa0 className={iconProps} />;
      case 1:
        return <Fa1 className={iconProps} />;
      case 2:
        return <Fa2 className={iconProps} />;
      case 3:
        return <Fa3 className={iconProps} />;
      case 4:
        return <Fa4 className={iconProps} />;
      case 5:
        return <Fa5 className={iconProps} />;
      default:
        return <Fa5 className={iconProps} />;
    }
  };

  const getNavItemClass = (path: string) => {
    // Para o item Torneios, queremos destacar se a rota for /torneios ou /torneios/super12
    const locationPath = location.pathname;

    // Aqui um exemplo para o item torneios
    if (
      path === "/torneios" &&
      (locationPath === "/torneios" ||
        locationPath === "/torneios/super12" ||
        locationPath === "/torneios/super8" ||
        locationPath === "/torneios/super16" ||
        locationPath === "/torneios/jogos")
    ) {
      return `group mx-1 flex items-center gap-3 rounded-2xl px-3 py-3 text-sm font-medium transition ${
        isCollapsed ? "justify-center" : ""
      } bg-gradient-to-r from-pink-500/35 to-rose-500/25 text-white ring-1 ring-pink-300/35 shadow-[0_10px_30px_rgba(244,114,182,0.22)]`;
    }

    // Para os outros itens: estilo normal
    return `group mx-1 flex items-center gap-3 rounded-2xl px-3 py-3 text-sm font-medium transition ${
      isCollapsed ? "justify-center" : ""
    } ${
      locationPath === path
        ? "bg-gradient-to-r from-pink-500/35 to-rose-500/25 text-white ring-1 ring-pink-300/35 shadow-[0_10px_30px_rgba(244,114,182,0.22)]"
        : "text-zinc-300 hover:bg-white/6 hover:text-white"
    }`;
  };

  return (
    <nav
      className={`flex h-full flex-col px-3 pb-4 ${
        isCollapsed ? "items-center" : ""
      }`}
    >
      <img
        className={`w-full h-auto p-8 pt-0 transition-opacity ${
          isCollapsed ? "opacity-0" : "opacity-100"
        }`}
        src={logowithe}
        alt="Logo"
      />
      <ul className="custom-scrollbar min-h-0 flex-1 space-y-2 overflow-y-auto pb-3">
        <li
          className={`flex items-center rounded-2xl border border-white/8 bg-white/4 px-3 py-3 ${
            isCollapsed ? "justify-center" : "gap-3"
          }`}
        >
          {getIconeJogos(jogosDoMes)}
          {!isCollapsed && (
            <span className="text-sm text-zinc-300 text-nowrap">
              {jogosDoMes === 1 ? "jogo nesse mês" : "jogos nesse mês"}
            </span>
          )}
        </li>

        <li
          onClick={() => navigate("/lista")}
          className={getNavItemClass("/lista")}
        >
          <FaClipboardList className="text-xl" />
          {!isCollapsed && <span>Lista para o play</span>}
        </li>
        <li
          onClick={() => navigate("/historico")}
          className={getNavItemClass("/historico")}
        >
          <FaHistory className="text-xl" />
          {!isCollapsed && <span className="text-nowrap">Histórico</span>}
        </li>
        <li
          onClick={() => navigate("/viciometro")}
          className={getNavItemClass("/viciometro")}
        >
          <IoStatsChartSharp className="text-xl" />
          {!isCollapsed && <span className="text-nowrap">Viciômetro</span>}
        </li>
        <li
          onClick={() => navigate("/regras")}
          className={getNavItemClass("/regras")}
        >
          <MdOutlineRule className="text-xl" />
          {!isCollapsed && <span className="text-nowrap">Regras</span>}
        </li>
        <li
          onClick={() => navigate("/torneios")}
          className={getNavItemClass("/torneios")}
        >
          <IoMdTrophy
            className={`text-xl ${torneioExiste ? "text-pink-300" : ""}`}
          />
          {!isCollapsed && <span className="text-nowrap">Torneios</span>}
        </li>
        <li
          onClick={() => navigate("/aniversarios")}
          className={getNavItemClass("/aniversarios")}
        >
          <FaBirthdayCake className="text-xl" />
          {!isCollapsed && <span className="text-nowrap">Aniversários</span>}
        </li>

        <li
          onClick={() => navigate("/configuracoes")}
          className={getNavItemClass("/configuracoes")}
        >
          <FaCog className="text-xl" />
          {!isCollapsed && <span className="text-nowrap">Configuraçoes</span>}
        </li>
        {userLevel && privilegedLevels.includes(userLevel) ? (
          <li
            onClick={() => navigate("/configuracoesadmin")}
            className={getNavItemClass("/configuracoesadmin")}
          >
            <RiAdminFill className="text-xl" />
            {!isCollapsed && <span className="text-nowrap">Administração</span>}
          </li>
        ) : (
          ""
        )}
      </ul>
      <div
        className={`mt-auto flex w-full items-center rounded-2xl px-3 py-3 text-sm font-medium text-zinc-300 transition hover:bg-white/6 hover:text-white ${
          isCollapsed ? "justify-center" : "gap-3"
        }`}
        onClick={handleLogoff}
      >
        <FaSignOutAlt className="text-xl" />
        {!isCollapsed && <span>Logout</span>}
      </div>
    </nav>
  );
};

export default Menu;
